import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {Button} from '../../atoms/Buttons/Button';
import {Icon, IconSize} from '../../atoms/Icon/Icon';
import {IconName} from '../../atoms/Icon/IconName';
import {Tooltip} from '../../atoms/Tooltip/Tooltip';

export interface HeaderButtonProps {
  className?: string;
  label: string;
  ariaLabel?: string;
  textColor?: keyof typeof COLORS;
  icon: IconName;
  iconSize?: keyof typeof IconSize;
  iconColor?: COLORS;
  backgroundColor?: COLORS | 'transparent';
  onClick: VoidFunction;
  dataTestId?: string;
}

export const HeaderCircleButton: React.FC<HeaderButtonProps> = ({
  className,
  label,
  ariaLabel,
  icon,
  iconSize = 'S',
  iconColor = COLORS.Grey1,
  backgroundColor = COLORS.White,
  onClick,
  dataTestId,
}) => {
  return (
    <Tooltip label={label} placement="bottom-center">
      <StyledCircleButton
        $backgroundColor={backgroundColor}
        data-testid={dataTestId}
        className={className}
        onClick={onClick}
        aria-label={ariaLabel ?? label}
        size="sm"
        round={true}
      >
        <Icon
          data-testid={`${dataTestId}_Icon`}
          asset={icon}
          size={iconSize}
          fill={iconColor}
        />
      </StyledCircleButton>
    </Tooltip>
  );
};

const StyledCircleButton = styled(Button)<{
  $backgroundColor: COLORS | 'transparent';
}>`
  && {
    background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
    min-height: 40px;
    width: 40px;
  }

  &&&:hover {
    background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
    svg {
      fill: ${({$backgroundColor}) =>
        $backgroundColor === COLORS.White ? COLORS.Black : COLORS.Grey1};
    }
  }
`;
